import { render } from "./PreOrderStripApp.vue?vue&type=template&id=b1f60652"
import script from "./PreOrderStripApp.vue?vue&type=script&lang=js"
export * from "./PreOrderStripApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__